import { ReactNode } from 'react';
import styles from './IconMessage.module.scss';

export interface IconMessageProps {
  icon: string;
  title?: string;
  children: ReactNode;
}

export const IconMessage = (props: IconMessageProps) => {
  return (
    <div className={styles['icon-message']}>
      <i className={[styles.icon, props.icon].join(' ')} />
      <div className={styles['text-content']}>
        {props.title && <span className={styles.title}>{props.title}</span>}
        <span className={styles.message}>{props.children}</span>
      </div>
    </div>
  );
};
